/* Copyright (C) 2018-2019 SplendidCRM Software, Inc. All Rights Reserved. 
 * Any use of the contents of this file are subject to the SplendidCRM Professional Source Code License Agreement, or other written agreement between you and SplendidCRM ("License"). 
 * SplendidCRM owns all proprietary rights, including all copyrights, patents, trade secrets, and trademarks, in and to the contents of this file.  You will not link to or in any way 
 * combine the contents of this file or any derivatives with any Open Source Code in any manner that would require the contents of this file to be made available to any third party. 
 */

export default interface RELATIONSHIPS
{
	ID                            : string  ; // uniqueidentifier
	RELATIONSHIP_NAME             : string  ; // nvarchar
	LHS_MODULE                    : string  ; // nvarchar
	LHS_TABLE                     : string  ; // nvarchar
	LHS_KEY                       : string  ; // nvarchar
	RHS_MODULE                    : string  ; // nvarchar
	RHS_TABLE                     : string  ; // nvarchar
	RHS_KEY                       : string  ; // nvarchar
	JOIN_TABLE                    : string  ; // nvarchar
	JOIN_KEY_LHS                  : string  ; // nvarchar
	JOIN_KEY_RHS                  : string  ; // nvarchar
	RELATIONSHIP_TYPE             : string  ; // nvarchar
	RELATIONSHIP_ROLE_COLUMN      : string  ; // nvarchar
	RELATIONSHIP_ROLE_COLUMN_VALUE: string  ; // nvarchar
	REVERSE                       : boolean ; // bit
}

